// =============================================================================
// Normascan — Plateforme d'analyse normative par IA
// Copyright (c) 2026-2027 Evalens SAS — Tous droits réservés
// Marque Normascan déposée INPI n°5242986 (classes 9 et 42)
// Site : https://app.normascan.fr
// =============================================================================
//
// Navigation — barre latérale, menu utilisateur, entrées d'accès aux pages.
//
// Les deux langues vivent dans le même fichier : `CLAUDE.md` impose d'ajouter
// toute clé en fr ET en en simultanément, et côte à côte l'oubli se voit dans le
// diff. La parité est par ailleurs vérifiée par `tests/unit/test_i18n_parity.py`.

const navigation = {
  fr: {
    nav_norma:               'NORMA',
    nav_analyses:            'Mes analyses',
    nav_my_stats:            'Mes statistiques',
    nav_verifier_certification: 'Vérifier une certification',
    nav_stats:               'Statistiques',
    nav_annotations:         'Annotations',
    nav_ratings:             'Évaluations',
    nav_retours:             'Signalements',
    nav_new_project:         'Nouveau projet',
    nav_recent:              'Récents',
    nav_projects:            'Projets',
    nav_users:               'Utilisateurs',
    nav_enterprise:          'Clients Entreprise',
    nav_audit:               'Journal d\'audit',
    nav_license_portal:      'Espace client',
    nav_whatsnew:            'Nouveautés',

    // Registre des mises à jour — pop-up au login + page dédiée. Seul le CHROME
    // passe par ici : le texte des notes vit dans `data/changelog.js`, en fr ET
    // en en, sous la garde de `tests/unit/test_changelog.py`.
    whatsnew_title:          'Nouveautés de cette mise à jour',
    whatsnew_version:        'Version',
    whatsnew_close:          'Fermer',
    whatsnew_got_it:         'J\'ai compris',
    whatsnew_see_all:        'Voir toutes les nouveautés',
    whatsnew_page_title:     'Nouveautés',
    whatsnew_page_subtitle:  'Historique des mises à jour de Normascan',

    menu_profile:            'Profil',
    menu_prefs:              'Préférences',
    menu_settings:           'Paramètres',
    menu_billing:            'Abonnement',
    menu_help:               'Obtenir de l\'aide',
    menu_terms:              'Conditions générales',
    menu_logout:             'Se déconnecter',

    sidebar_copy_done:       'Copié !',
    sidebar_analyses_suffix: 'analyses',
    sidebar_quota_personnel: 'Votre quota personnel, fixé par l’administrateur de votre licence',
    sidebar_pool_licence:    'Analyses consommées sur le pool partagé de votre licence',
    sidebar_show_more:       'Plus.',
    sidebar_show_less:       'Moins.',
  },

  en: {
    nav_norma:               'NORMA',
    nav_analyses:            'My analyses',
    nav_my_stats:            'My statistics',
    nav_verifier_certification: 'Check a certification',
    nav_stats:               'Statistics',
    nav_annotations:         'Annotations',
    nav_ratings:             'Ratings',
    nav_retours:             'Reports',
    nav_new_project:         'New project',
    nav_recent:              'Recent',
    nav_projects:            'Projects',
    nav_users:               'Users',
    nav_enterprise:          'Enterprise Clients',
    nav_audit:               'Audit log',
    nav_license_portal:      'Client portal',
    nav_whatsnew:            'What\'s new',

    whatsnew_title:          'What\'s new in this release',
    whatsnew_version:        'Version',
    whatsnew_close:          'Close',
    whatsnew_got_it:         'Got it',
    whatsnew_see_all:        'See all updates',
    whatsnew_page_title:     'What\'s new',
    whatsnew_page_subtitle:  'Normascan release history',

    menu_profile:            'Profile',
    menu_prefs:              'Preferences',
    menu_settings:           'Settings',
    menu_billing:            'Subscription',
    menu_help:               'Get help',
    menu_terms:              'Terms of service',
    menu_logout:             'Sign out',

    sidebar_copy_done:       'Copied!',
    sidebar_analyses_suffix: 'analyses',
    sidebar_quota_personnel: 'Your personal quota, set by your license administrator',
    sidebar_pool_licence:    'Analyses used from your license’s shared pool',
    sidebar_show_more:       'More.',
    sidebar_show_less:       'Less.',
  },
};

export default navigation;
